import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import Slider from 'react-slick';
import './ProductCarousel.scss';
import { v4 } from 'uuid';
import { useSelector } from 'react-redux';
import { replaceImageURL } from '../../../../own-days/helper';
import '../../../../own-days/CommonComponents/OdButton/OdButton.scss';

const ProductCarousel = props => {
  const { productData, colorPreviewImageUrl, setShowTryOnPopUp, setShow360View } = props;
  const localeInfo = useSelector(state => state.common.localeInfo);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);
  const [sliderCount, setSliderCount] = useState(500);
  const sliderHeight = useRef(null);

  const slidsList = useMemo(() => {
    return [...productData?.result?.imageUrlsDetail];
  }, [productData?.result?.imageUrlsDetail]);

  const [colorHoverImg, setColorHoverImg] = useState(colorPreviewImageUrl);

  useEffect(() => {
    setColorHoverImg(colorPreviewImageUrl);
  }, [colorPreviewImageUrl]);

  async function loadImage(src) {
    const image = new Image();

    await new Promise((resolve, reject) => {
      image.onerror = () => {
        reject();
      };
      image.onload = resolve;
      image.src = src;
    });
  }

  const loadImages = useCallback(async () => {
    if (colorHoverImg) {
      try {
        await loadImage(colorHoverImg);
      } catch {
        setColorHoverImg(
          'https://static.lenskart.com/media/owndays/desktop/img/od-misc/no-image.jpg'
        );
      }
    }

    if (slidsList && slidsList.length > 0) {
      await Promise.all(
        slidsList.map(async slide => {
          try {
            await loadImage(replaceImageURL(slide.url, localeInfo, productData?.result?.id));
          } catch (error) {
            slide.url =
              'https://static.lenskart.com/media/owndays/desktop/img/od-misc/no-image.jpg';
          }
        })
      );
    }
  }, [colorHoverImg, localeInfo, productData?.result?.id, slidsList]);

  useEffect(() => {
    loadImages();
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, [loadImages]);

  return (
    <section className="product-slider">
      <div className="slick-nav" style={{ height: `${sliderCount}px` }}>
        <Slider
          ref={slider => (sliderRef2 = slider)}
          arrows
          focusOnSelect
          swipeToSlide
          vertical
          verticalSwiping
          asNavFor={nav1}
          dots={false}
          slidesToScroll={1}
          slidesToShow={slidsList?.length > 5 ? 5 : slidsList?.length}
        >
          {slidsList.map(slide => {
            return (
              <div key={v4()} className="slick-img">
                <img
                  alt="product slide img"
                  src={
                    colorHoverImg ||
                    replaceImageURL(slide?.url, localeInfo, productData?.result?.id)
                  }
                />
              </div>
            );
          })}
        </Slider>
      </div>
      <div ref={sliderHeight} className="slick-for">
        <div className="product-top__tags">
          {productData?.result?.sortingTag?.imageUrl && (
            <span className="product-top__tag">
              <img
                alt={productData?.result?.sortingTag?.label}
                loading="lazy"
                src={productData?.result?.sortingTag?.imageUrl}
              />
            </span>
          )}
          {productData?.result?.customTags?.map(tag => (
            <span key={tag?.label} className="product-top__tag">
              {tag?.label}
            </span>
          ))}
        </div>
        <Slider ref={slider => (sliderRef1 = slider)} asNavFor={nav2}>
          {slidsList.map(slide => {
            return (
              <div key={v4()} className="slick-img">
                <img
                  alt="product slide img"
                  src={
                    colorHoverImg ||
                    replaceImageURL(slide?.url, localeInfo, productData?.result?.id)
                  }
                />
              </div>
            );
          })}
        </Slider>
        {productData?.result?.classification !== 'contact_lens' && (
          <>
            {Number(productData?.result?.id) !== 221925 && productData?.result?.glassOnUrl ? (
              <div className="product-slider__btn">
                <button className="odButton" onClick={() => setShowTryOnPopUp(true)}>
                  <img
                    alt="Try on"
                    src="https://static.lenskart.com/owndays/img/pdp/try-on-2.svg"
                    width={17}
                  />
                  Try on
                </button>
                <button className="odButton odButton--outline" onClick={() => setShow360View(true)}>
                  <img
                    alt="360˚View"
                    src="https://static.lenskart.com/owndays/img/pdp/360.svg"
                    width={17}
                  />
                  360˚View
                </button>
              </div>
            ) : null}
          </>
        )}
      </div>
    </section>
  );
};

export default ProductCarousel;
